import noop from 'lodash/noop'
import React, { useEffect, useState } from 'react'
import { Popover, PopoverPosition } from 'react-tiny-popover'
import { ReactComponent as InfoIcon } from 'icons/info.svg'

type Positions = Exclude<PopoverPosition, 'custom'>[]

interface InfoPopoverProps {
  text: React.ReactNode | string
  iconId?: string
  className?: string
  children?: JSX.Element | null
  positions?: Positions
  open?: boolean
  showOnClick?: boolean
  onIconClick?(): void
  iconColor?: string
}

const defaultPositions = ['right', 'top', 'left', 'bottom'] as Positions

export default function InfoPopover(props: InfoPopoverProps) {
  const {
    text,
    className,
    children = null,
    positions = defaultPositions,
    open = false,
    showOnClick = false,
    onIconClick = noop,
    iconColor = 'text-red',
  } = props

  const [isPopoverOpen, setPopoverOpen] = useState(false)
  const [triggerHover, setTriggerHover] = useState(false)
  const [isContentHover, setIsContentHover] = useState(false)

  useEffect(() => {
    if (showOnClick) {
      return
    }
    if (triggerHover) {
      setPopoverOpen(true)
      return
    }

    if (!triggerHover && !isContentHover) {
      setPopoverOpen(false)
    }
  }, [isContentHover, showOnClick, triggerHover])

  const handleMouseEnter = () => {
    if (showOnClick) {
      return
    }
    setTriggerHover(true)
  }

  const handleIconClick = () => {
    if (showOnClick) {
      setPopoverOpen(true)
      onIconClick()
    }
  }

  const ch = children
    ? React.Children.map(children, (child) =>
        React.cloneElement(child, {
          onMouseEnter: handleMouseEnter,
          onMouseLeave: () => setTriggerHover(false),
        })
      )
    : null
  const handleContentClick = (e: React.MouseEvent) => {
    e.stopPropagation()
  }

  return (
    <Popover
      isOpen={isPopoverOpen || open}
      padding={8}
      positions={positions}
      content={() => (
        <div
          className={`popover-con relative z-50 rounded-base border border-yellow/50 bg-black p-[0.66rem] font-mono text-[0.88rem] leading-4 text-yellow/75 ${className}`}
          onClick={handleContentClick}
          onMouseEnter={() => setIsContentHover(true)}
          onMouseLeave={() => setIsContentHover(false)}
        >
          {text}
        </div>
      )}
    >
      {ch ? (
        ch[0]
      ) : (
        <div
          className="relative z-30 ml-2 inline-block cursor-default"
          onMouseEnter={handleMouseEnter}
          onMouseLeave={() => setTriggerHover(false)}
          onClick={handleIconClick}
        >
          <InfoIcon
            className={` ${iconColor} h-3.5 w-3.5 fill-current opacity-50 hover:opacity-100`}
          />
        </div>
      )}
    </Popover>
  )
}
